import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography } from '@mui/material';
import { toast } from 'react-toastify';

import FleetForm from './FleetForm';
import { updateVehicle } from './FleetSlice';

function UpdateVehicle () {
    const { isLoading, fleet } = useSelector((state) => state.fleet);
    const { vehicleId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fleetDetails = fleet.filter((vehicle) => {return (vehicle.id.toString() === vehicleId)})[0];
    const [registration, setRegistration] = useState(fleetDetails.registration);
    const [model, setModel] = useState(fleetDetails.model);
    const [locations, setLocations] = useState(fleetDetails.locations);
    const [isPlaceholder, setIsPlaceholder] = useState(fleetDetails.is_placeholder);
    const [forRental, setForRental] = useState(fleetDetails.for_rental);
    const [forTransfers, setForTransfers] = useState(fleetDetails.for_transfers);
    const [forChauffeur, setForChauffeur] = useState(fleetDetails.for_chauffeur);
    const vehicle = {
        id: fleetDetails.id,
        registration: registration,
        model: model,
        locations: locations,
        owner: fleetDetails.owner,
        is_placeholder: isPlaceholder,
        for_rental: forRental,
        for_transfers: forTransfers,
        for_chauffeur: forChauffeur
    }

    const handleNewLocation = (event) => {
        const {target: {value},} = event;
        setLocations(typeof value === 'string' ? value.split(',') : value)
    }
    
    const handleSubmit = (event) => {
        event.preventDefault();
        if (
            registration !== fleetDetails.registration ||
            model !== fleetDetails.model ||
            locations !== fleetDetails.locations ||
            isPlaceholder !== fleetDetails.is_placeholder ||
            forRental !== fleetDetails.for_rental ||
            forTransfers !== fleetDetails.for_transfers ||
            forChauffeur !== fleetDetails.for_chauffeur
        ) {
            dispatch(updateVehicle(vehicle));
            navigate('/manage/fleet');
        } else {
            toast.info('No update');
        }
    }

    return (
        <Container>
            <Typography variant='h3' align='center' gutterBottom>
                Update car
            </Typography>
            <Paper sx={{padding: 2}}>
                <FleetForm 
                    action='update'
                    isLoading={isLoading}
                    vehicle={vehicle}
                    onRegistrationChange={setRegistration}
                    onModelChange={setModel}
                    onLocationChange={handleNewLocation}
                    onPlaceholderChange={setIsPlaceholder}
                    onForRentalChange={setForRental}
                    onForTransfersChange={setForTransfers}
                    onForChauffeurChange={setForChauffeur}
                    handleSubmit={handleSubmit}
                />
            </Paper>
        </Container>
    )
}

export default UpdateVehicle